<div *ngIf="pipes.length == 1">
  <div *ngIf="pipes.length == 1" class="pipe-form-field">
    <dx-button text="Multiple Pipes" (onClick)="addPipe()"></dx-button>
  </div>
  <div class="pcc-field">
    <div class="pcc-field-label">Standard Pipe Size</div>
    <div class="pcc-field-value" style="width:300px">
      <lib-standard-pipe-selector #standardPipeSelector (onPipeSelect)="applyStandardPipe($event)">
      </lib-standard-pipe-selector>
    </div>
  </div>
  <div class="pcc-field">
    <div class="pcc-field-label">Section</div>
    <div class="pcc-field-value">
      <dx-select-box [items]="sections" [(value)]="pipes[0].section" width="150" (onValueChanged)="valueChanged()">
      </dx-select-box>
    </div>
  </div>
  <lib-number-field [quantity]="quantity.XDIM" [error]="errors[labels[keys.diameter]]"
    (valueChange)="pipes[0].xdim1=$event;valueChanged();" [(value)]="pipes[0].xdim1" [visible]="pipes[0].section == 'Circular'"
    [label]="labels[keys.diameter]"></lib-number-field>
  <lib-number-field [quantity]="quantity.XDIM" [error]="errors[labels[keys.insideDiameter]]"
    (valueChange)="pipes[0].xdim1=$event;valueChanged();" [(value)]="pipes[0].xdim1" [visible]="pipes[0].section == 'Annular'"
    [label]="labels[keys.insideDiameter]"></lib-number-field>
  <lib-number-field [quantity]="quantity.XDIM" [error]="errors[labels[keys.radialGap]]"
    (valueChange)="pipes[0].xdim2=$event;valueChanged();" [(value)]="pipes[0].xdim2" [visible]="pipes[0].section == 'Annular'"
    [label]="labels[keys.radialGap]"></lib-number-field>
  <lib-number-field [quantity]="quantity.XDIM" [error]="errors[labels[keys.width]]"
    (valueChange)="pipes[0].xdim1=$event;valueChanged();" [(value)]="pipes[0].xdim1" [visible]="pipes[0].section == 'Rectangular'"
    [label]="labels[keys.width]"></lib-number-field>
  <lib-number-field [quantity]="quantity.XDIM" [error]="errors[labels[keys.height]]"
    (valueChange)="pipes[0].xdim2=$event;valueChanged();" [(value)]="pipes[0].xdim2" [visible]="pipes[0].section == 'Rectangular'"
    [label]="labels[keys.height]"></lib-number-field>
  <lib-number-field [quantity]="quantity.LENGTH" [error]="errors[labels[keys.length]]"
    (valueChange)="pipes[0].length=$event;valueChanged();" [(value)]="pipes[0].length" [label]="labels[keys.length]">
  </lib-number-field>
  <lib-number-field [error]="errors[labels[keys.bends]]" (valueChange)="pipes[0].bends=$event;valueChanged();"
    [(value)]="pipes[0].bends" [label]="labels[keys.bends]"></lib-number-field>
  <lib-number-field [error]="errors[labels[keys.numberInParallel]]" (valueChange)="pipes[0].parallel=$event;valueChanged();"
    [(value)]="pipes[0].parallel" [label]="labels[keys.numberInParallel]"></lib-number-field>

</div>
<lib-pipework *ngIf="pipes.length > 1" [(pipes)]="pipes" (editing)="editingPipes($event)" (listChanged)="listChanged($event)" (pipeClick)="pipeClick($event)" [errors]="errors[keys.pipeWorkErrors]"> </lib-pipework>